import { QuestionVariants } from 'domain/question';
import i18n from 'i18n';

export const ANSWERS_LIBRARY = i18n.t('question:answersLibrary', { returnObjects: true });

export const QUESTION_TYPE_LABEL_MAP: Record<QuestionVariants, string> = {
  [QuestionVariants.TextQuestion]: 'Free Text',
  [QuestionVariants.RankingQuestion]: 'Ranking',
  [QuestionVariants.MultipleChoiceSingleSelectQuestion]: 'Single Choice',
  [QuestionVariants.MultipleChoiceMultipleSelectQuestion]: 'Multiple Choice',
  [QuestionVariants.NPSQuestion]: 'Net Promoter Score (NPS)',
  [QuestionVariants.SliderQuestion]: 'Slider',
} as const;

export const REQUIRED_QUESTION_MESSAGE = 'This is a required question.';

export const MAX_QUESTION_TITLE_LENGTH = 5000;
export const MAX_QUESTION_ANSWER_OPTION_LENGTH = 5000;
